module.exports = __webpack_public_path__ + "6098a68fc59d224c1b5823c5c8032b69.ttf";